module.exports = __webpack_public_path__ + "static/media/security.0ac5e1b7.svg";